<template>
  <a href="javascript:;">
    <div style="display: inline-block; min-width: 131.42px;">
      <transition enter-active-class="animate__animated animate__fast animate__flipInY" mode="out-in">
        <img v-if="fgSistema == 'CLINIC'" alt="Logo" src="/assets/custom/logos/icone-clinic.png" class="h-40px h-lg-40px" />
      </transition>
      <transition enter-active-class="animate__animated animate__fast animate__flipInY" mode="out-in">
        <img v-if="fgSistema == 'CASH'" alt="Logo" src="/assets/custom/logos/icone-cash.png" class="h-40px h-lg-40px" />
      </transition>
      <transition enter-active-class="animate__animated animate__fast animate__flipInY" mode="out-in">
        <img v-if="fgSistema == 'BOT'" alt="Logo" src="/assets/custom/logos/icone-bot.png" class="h-40px h-lg-40px" />
      </transition>
      <transition enter-active-class="animate__animated animate__fast animate__flipInY" mode="out-in">
        <img v-if="fgSistema == 'ANALYTICS'" alt="Logo" src="/assets/custom/logos/icone-analytics.png" class="h-40px h-lg-40px" />
      </transition>
      <transition enter-active-class="animate__animated animate__fast animate__flipInY" mode="out-in">
        <img v-if="fgSistema == 'QUALITY'" alt="Logo" src="/assets/custom/logos/icone-quality.png" class="h-40px h-lg-40px" />
      </transition>
    </div>
    <span v-if="!hidechangebutton" class="svg-icon svg-icon-1" style="margin-left: 4px;" @click="trocaSistema">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor"/>
        <path d="M11.9343 12.5657L9.53696 14.963C9.22669 15.2733 9.18488 15.7619 9.43792 16.1204C9.7616 16.5789 10.4211 16.6334 10.8156 16.2342L14.3054 12.7029C14.6903 12.3134 14.6903 11.6866 14.3054 11.2971L10.8156 7.76582C10.4211 7.3666 9.7616 7.42107 9.43792 7.87962C9.18488 8.23809 9.22669 8.72669 9.53696 9.03696L11.9343 11.4343C12.2467 11.7467 12.2467 12.2533 11.9343 12.5657Z" fill="currentColor"/>
      </svg>
    </span>
  </a>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "LogoSistema", 
  props: ["hidechangebutton"], 
  computed: {
    ...mapGetters(["fgSistema"])
  }, 
  methods: {
    ...mapActions(["updatefgSistema", "getValidateToken", "atualizarLoadingPerfil"]), 
    async trocaSistema() {
      if(this.fgSistema == "CLINIC") {
        this.updatefgSistema("CASH");
        document.title = "Cash by Micrologos";
      } else if(this.fgSistema == "CASH") {
        this.updatefgSistema("BOT");
        document.title = "Bot by Micrologos";
      } else if(this.fgSistema == "BOT") {
        this.updatefgSistema("ANALYTICS");
        document.title = "Analytics by Micrologos";
      } else if(this.fgSistema == "ANALYTICS") {
        this.updatefgSistema("CLINIC");
        document.title = "Clinic by Micrologos";
      }

      await this.$nextTick();
      
      this.atualizarLoadingPerfil(true);
      await this.getValidateToken();
      this.atualizarLoadingPerfil(false);

      this.emitter.emit("atualizarMenuFavoritos", {});
    }
  }
}

</script>

<style scoped>

</style>